import React from 'react';

const SIZE_CLASSES = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
  xl: 'h-12 w-12',
};

const LoadingSpinner = ({ size = 'md', className = '' }) => (
  <div
    role='status'
    aria-label='Loading'
    className={`animate-spin rounded-full border-2 border-gray-300 border-t-primary-600 ${SIZE_CLASSES[size]} ${className}`}
  ></div>
);

export default LoadingSpinner;
